<div class="page-container no-scroll inner-padding">
    <app-header title="import.importEmployeeData" [badgeOptions]="{ label: 'beta', type: 'default' }">
        <ui-button
            *ngIf="importService.hasImportType('FILE') && importService.IMPORT_CONFIGS.FILE as importFromFile"
            class="buttons"
            type="outline"
            [routerLink]="importFromFile.routerLink"
        >
            <mat-icon [svgIcon]="importFromFile.icon"></mat-icon>
            {{ 'import.types.FILE.title.LONG' | translate }}</ui-button
        >
    </app-header>
    <app-steps
        [id]="(integrationService.integrationInProgress | async)?.name ?? 'CHOOSE-SOFTWARE'"
        [steps]="[listSoftware, connectionPreview, importPreview, summary]"
        [activeStep]="activeStepIndex"
    >
        <app-step [class.active]="activeStepIndex === 0" #listSoftware step="import.integrations.steps.software.title">
            <app-integrations-choose-software *ngIf="activeStepIndex === 0" />
        </app-step>
        <app-step
            [class.active]="activeStepIndex === 1"
            #connectionPreview
            step="import.integrations.steps.connect.title"
        >
            <app-integrations-connection-preview *ngIf="activeStepIndex === 1" />
        </app-step>
        <app-step [class.active]="activeStepIndex === 2" #importPreview step="import.integrations.steps.preview.title">
            <app-integrations-import-preview *ngIf="activeStepIndex === 2" />
        </app-step>
        <app-step [class.active]="activeStepIndex === 3" #summary step="import.integrations.steps.summary.title">
            <app-integrations-summary *ngIf="activeStepIndex === 3" />
        </app-step>
    </app-steps>
</div>
